var _excluded = ["to", "href", "title", "onClick", "onMouseEnter", "onMouseLeave", "openInNewTab", "rel", "className", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, forwardRef, useRef } from "react";
import LinkComponentContext from "../../../contexts/LinkComponentContext";
import { KeyboardEventKeys } from "../../../typings/types";
import throwError from "../../../utils/throwError";
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var to = _ref.to,
    href = _ref.href,
    title = _ref.title,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    openInNewTab = _ref.openInNewTab,
    rel = _ref.rel,
    className = _ref.className,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var LinkComponent = useContext(LinkComponentContext);
  var defaultRef = useRef(null);
  var actualRef = ref || defaultRef;
  var onKeyDown = function onKeyDown(event) {
    if (actualRef && (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE)) {
      var _current;
      event.preventDefault();
      (_current = actualRef.current) === null || _current === void 0 || _current.click();
    }
  };
  var commonProps = {
    title: title,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    target: openInNewTab ? "_blank" : undefined,
    rel: rel && (typeof rel === "string" ? rel : rel.join(" ")),
    ref: actualRef,
    className: className
  };
  if (to) {
    if (!LinkComponent) {
      return throwError('You have to pass Link component through <Hel>\'s "linkComponent" prop if you want to use the "to" prop');
    }
    return /*#__PURE__*/React.createElement(LinkComponent, _extends({}, commonProps, {
      to: to
    }, restProps), children);
  }
  return /*#__PURE__*/React.createElement("a", _extends({}, commonProps, {
    href: href,
    tabIndex: href ? undefined : 0
  }, restProps), children);
});
export default Link;